import(/* webpackMode: "eager" */ "/app/src/app/(main)/chinh-sach-quy-dinh-chung/page.tsx");
